import UsersList from "../../components/Table/UsersList";

const AdminUser = () => <UsersList />;
export default AdminUser;
